// Single Phaser EventEmitter shared between all Phaser scenes and the React wrapper.
// React components and Phaser scenes both import this module-level singleton.
import Phaser from 'phaser';

declare global {
	interface Window {
		__bridgeEventBus__?: Phaser.Events.EventEmitter;
		__bridgeDialogOpen__?: boolean;
	}
}

export const EVENTS = {
	// ── Phaser → React ───────────────────────────────────────────────────────
	// Player entered an open door; payload: RoomChangePayload.
	ROOM_CHANGE: 'roomChange',
	// Step tile pressed (payload: StepTileData) or released (payload: null).
	STEP_TILE_ACTIVATE: 'stepTileActivate',
	// Screen-space anchor for the active step-tile tooltip (payload: {x, y} or null).
	STEP_TILE_TOOLTIP_POS: 'stepTileTooltipPos',
	// Text for the active closed-door tooltip (payload: string or null).
	DOOR_TOOLTIP: 'doorTooltip',
	// Screen-space anchor for the active closed-door tooltip (payload: {x, y} or null).
	DOOR_TOOLTIP_POS: 'doorTooltipPos',
	// Player pressed locker-computer face (no payload).
	LOCKER_OPEN: 'lockerOpen',
	// Player entered/left a messenger element; payload: MessengerData or null.
	MESSENGER_ACTIVATE: 'messengerActivate',
	// BootScene create() finished; React may now send LOAD_ROOM.
	SCENE_READY: 'sceneReady',
	// Dev-only editable element/collision selection payload.
	DEV_EDITABLE_SELECT: 'devEditableSelect',
	// Clear the current dev-only editable selection.
	DEV_EDITABLE_CLEAR: 'devEditableClear',

	// ── React → Phaser ───────────────────────────────────────────────────────
	// Bootstrap or reload a room; payload: LoadRoomPayload.
	LOAD_ROOM: 'loadRoom',
	// Suppress player input while a dialog is open; payload: boolean.
	SET_DIALOG_OPEN: 'setDialogOpen',
	// Dev-only live rect update for an editable element or collision.
	DEV_EDITABLE_UPDATE: 'devEditableUpdate',
} as const;

export const EventBus =
	window.__bridgeEventBus__ ?? (window.__bridgeEventBus__ = new Phaser.Events.EventEmitter());

export function setBridgeDialogOpenState(open: boolean): void {
	window.__bridgeDialogOpen__ = open;
}

export function getBridgeDialogOpenState(): boolean {
	return window.__bridgeDialogOpen__ ?? false;
}
